import React from 'react';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ParticipationRowStatus } from '@app/models/users';

const STATUS_COLOR: Record<ParticipationRowStatus, string> = {
  [ParticipationRowStatus.Inactive]: 'default',
  [ParticipationRowStatus.AwaitingActivation]: 'processing',
  [ParticipationRowStatus.Active]: 'success',
  [ParticipationRowStatus.Deactivated]: 'error',
};

interface IProps {
  status: ParticipationRowStatus;
}

export const ParticipationStatusTag: React.FC<IProps> = ({ status }) => {
  const spaceT = useTranslation(NSKeys.spaceSettings);

  return <Tag color={STATUS_COLOR[status]}>{spaceT.t(`participationStatus.${status}` as const)}</Tag>;
};
